import React, { useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { CircularProgressBar } from '@cambridgeassessment/cambridge-ui';
import {
  StyledInputContainer,
  StyledInputBase,
  StyledIconContainer,
  StyledIconButton,
  StyledTooltip,
} from './SearchField.styles';

interface Props {
  value?: string;
  isLoading: boolean;
  onClearValue: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder?: string;
  className?: string;
}

const SearchField: React.FC<Props> = ({
  isLoading,
  value = '',
  onClearValue,
  onChange,
  placeholder = '',
  className,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <StyledInputContainer className={className} focus={focused}>
      <StyledIconContainer focus={focused}>
        <SearchIcon fontSize='small' />
      </StyledIconContainer>
      <StyledInputBase
        placeholder={placeholder}
        onChange={onChange}
        data-qa-id='search-field-input'
        id='searchField'
        autoFocus={focused}
        value={value}
        onBlur={() => setFocused(false)}
        onFocus={() => setFocused(true)}
      />

      {isLoading ? (
        <StyledIconContainer>
          <CircularProgressBar variant={'indeterminate'} size={20} dataQaId='search-progress-bar' />
        </StyledIconContainer>
      ) : (
        value && (
          <StyledTooltip arrow title='Clear search'>
            <StyledIconButton onClick={onClearValue} data-qa-id='clear-search-field'>
              <CloseIcon fontSize='small' />
            </StyledIconButton>
          </StyledTooltip>
        )
      )}
    </StyledInputContainer>
  );
};

export default SearchField;
